import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, InnerHeading, MainHeading, SpanStyled, TitleHeading } from '../../../ui/Elements'
import { ArrowBtnBrown, BrandArrowLeft, BrandArrowRight, ComMap, MBS, ServicesBg, ServicesImg, ServicesImgAr, StatsBg1, StatsBg2, StatsBg3, StatsBg4, StripeBg, StripeBgAr, Vision, VisionAr, VisionBg, VisionBgAr } from '../../../ui/AllImages'
import Slider from 'react-slick'
import { useTranslation } from 'react-i18next'
import { AboutBox } from '../../../ui/CustomElements'
import i18n from '../../../Languages/INEXT'
import { BrandDataConfig, ServicesList, StatsList, VisionMissionList, WhyChooseList } from '../../projectData/Data'
import { Animate } from 'react-simple-animate'
const Clients = () => {
    const { t } = useTranslation();
    const sectionRef = useRef(null);
                          const [isVisible, setIsVisible] = useState(false);
    const settings = {
        autoplay: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 5,
        slidesToScroll: 1,
        swipeToSlide: true,
        pauseOnHover: false,
        nextArrow: <BrandArrowRight />,
        prevArrow: <BrandArrowLeft />,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    }
    useEffect(() => {
                            const observer = new IntersectionObserver(
                              ([entry]) => {
                                // When visible, set to true
                                if (entry.isIntersecting) {
                                  setIsVisible(true);
                                  observer.disconnect(); // run animation once
                                }
                              },
                              {
                                threshold: 0.2, // 20% of section visible triggers the animation
                              }
                            );
                        
                            if (sectionRef.current) {
                              observer.observe(sectionRef.current);
                            }
                        
                            return () => observer.disconnect();
                          }, []);
                            const start = { opacity: 0, transform: 'translateY(-40px)' };
                            const end = { opacity: 1, transform: 'translateY(0)' };
                            const start2 = { opacity: 0, transform: 'translateY(100px)' };
                            const end2 = { opacity: 1, transform: 'translateY(0)' };
    return (
        <>
        <Box id='Clients'>
            <ClientsWapper className='container-fluid secWhyChoose' ref={sectionRef}>
                <Container>
                    <Row className='clients-row'>
                        <Animate
                            play={isVisible}
                            duration={1}
                            delay={.5}
                            start={start}
                            end={end}
                        >
                        <MainHeading className='main-heading main-heading-clients pb-0'>
                            {t('ourPartners')}
                        </MainHeading>
                        </Animate>
                        <Animate
                            play={isVisible}
                            duration={1}
                            delay={1}
                            start={start}
                            end={end}
                        >
                        <Box className='clientsContentInner'>
                            <SpanStyled className='clients-txt' color='var(--text)' size="18px">
                                {t('partnersDescription')}
                            </SpanStyled>
                        </Box>
                        </Animate>
                        <Box className='w-100 brand-card' dir='ltr'>
                            <Animate
                            play={isVisible}
                            duration={1}
                            delay={1.5}
                            start={start}
                            end={end}
                        >
                            <Slider className='d-flex align-items-center justify-content-evenly' {...settings}>
                                {BrandDataConfig.map((list, key) => (
                                        <Box key={key} className={`brand-slider`}>
                                            {list.img}
                                        </Box>
                                    ))
                                }
                            </Slider>
                            </Animate>
                        </Box>
                            
                        
                    </Row>
                    
                </Container>
            </ClientsWapper>
            
        </Box>
        
        </>
    )
}
const ClientsWapper = styled.section`
    padding-top: 100px;
    
    /* padding-left: 0; */
    /* padding-right: 0; */

    .main-heading-clients{
        text-align: center;
        padding-bottom: 15px;
    }
    
    .clients-txt{
        width: 100%;
        text-align: center;
        margin-top: 25px;
    }
    .clientsContentInner{
        padding-left: 170px;
        padding-right: 170px;
    }
    
    .brand-card{
        padding-left: 72px;
        padding-right: 72px;
        margin-top: 70px;
    }

    .brand-slider {
        display: flex !important;
        align-items: center;
        justify-content: center;
        border-radius: 16px;
        background: var(--bg);
        height: 158px;
        border-radius: 50px 0 50px 0;
    }
    .brand-card .slick-list {
        width: 100% !important;
    }
    .brand-card .slick-track {
        position: relative;
        // top: 0;
        // left: 0;
        display: flex !important;
        // margin-left: auto;
        // margin-right: auto;
        // gap: 56px;
    }
    .slick-prev, .slick-next {
    width: 68px;
    height: 68px;
    }
    .slick-prev {
    left: -72px;
    }
    .slick-next {
    right: -72px;
    }
    .slick-slide > div{
        padding-left: 28px;
        padding-right: 28px;
    }
   
    body.rtl &{
        .sub-heading-whyChoose{
            font-size: 48px;
        }
        .clients-txt{
            
        }
        .slick-slide {
            float: left !important;
            direction: rtl !important;
        }
        .slick-prev {
            left: -72px;
            right: unset;
        }
        .slick-next {
            right: -72px;
            left: unset;
        }
        .brand-slider {
            border-radius: 0 50px 0 50px;
        }
    }
    @media (max-width: 1399px) {
        .brand-card {
            padding-left: 92px;
            padding-right: 92px;
        }
    }
    @media (max-width: 1299px) {
        .clientsContentInner{
            padding-left: 100px;
            padding-right: 100px;
        }
        .slick-slide > div{
            padding-left: 15px;
            padding-right: 15px;
        }
        
    }
    @media (max-width: 1199px) {
        padding-top: 60px;
        .clientsContentInner{
            padding-left: calc(var(--bs-gutter-x) * .5);
            padding-right: calc(var(--bs-gutter-x) * .5);
        }
        .slick-slide > div{
            padding-left: 10px;
            padding-right: 10px;
        }
        
        
    }
    @media (max-width: 991px) {
        body.rtl &{
            .main-heading-clients{
                font-size: 45px !important;
            }
        }
        
    }
    @media (max-width: 767px) {
        .slick-prev, .slick-next {
            width: 40px;
            height: 40px;
        }
         .brand-card {
            padding-left: 72px;
            padding-right: 72px;
        }
        body.rtl &{
            .slick-next {
                right: -52px;
                left: unset;
            }
            .slick-prev {
                left: -52px;
                right: unset;
            }
        }
    }
    @media (max-width: 575px) {
        
    }
`
export default Clients
